import React from 'react';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import SurveyForm from './pages/SurveyForm';
import LoginForm from './pages/LoginForm';
import Dashboard from './pages/AdminDashboard';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import ProtectedRoute from './components/auth/ProtectedRoute';

// Create a custom theme with maroon colors
const theme = createTheme({
  palette: {
    primary: {
      main: '#800000', // Maroon as primary color
      light: '#a52a2a', // Lighter maroon
      dark: '#4d0000', // Darker maroon
    },
    secondary: {
      main: '#a52a2a', // Brick red as secondary color
    },
    background: {
      default: '#f5f5f5', // Light gray background
    },
    text: {
      primary: '#333333',
      secondary: '#800000', // Maroon for secondary text
    },
  },
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    h4: {
      fontWeight: 600,
      color: '#800000',
    },
    h5: {
      fontWeight: 600,
      color: '#800000',
    },
    h6: {
      fontWeight: 500,
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 8,
          textTransform: 'none',
          fontWeight: 500,
        },
        contained: {
          backgroundColor: '#800000',
          color: 'white',
          '&:hover': {
            backgroundColor: '#600000',
          },
        },
      },
    },
    MuiPaper: {
      styleOverrides: {
        root: {
          borderRadius: 8,
        },
      },
    },
    MuiRadio: {
      styleOverrides: {
        root: {
          color: '#800000',
          '&.Mui-checked': {
            color: '#800000',
          },
        },
      },
    },
    MuiCheckbox: {
      styleOverrides: {
        root: {
          color: '#800000',
          '&.Mui-checked': {
            color: '#800000',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          '& .MuiOutlinedInput-root': {
            '&.Mui-focused fieldset': {
              borderColor: '#800000',
            },
          },
          '& .MuiInputLabel-root.Mui-focused': {
            color: '#800000',
          },
        },
      },
    },
  },
});


function App() {
  return (
    
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginForm />} />
          <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
          />
          <Route path="/survey" element={<SurveyForm />} />

          <Route path="*" element={<Navigate to="/login" replace />} />
          <Route path="/" element={<SurveyForm />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  );
}
export default App;